export const GET_PAYMENT_METHODS = '[Payment] Get Payment Methods';
export const GET_PAYMENT_METHODS_SUCCESS =
  '[Payment] Get Payment Methods Success';
export const GET_PAYMENT_METHODS_ERROR = '[Payment] Get Payment Methods Error';

export const ADD_PAYMENT_METHOD = '[Payment] Add Payment Method';
export const ADD_PAYMENT_METHOD_SUCCESS =
  '[Payment] Add Payment Method Success';
export const ADD_PAYMENT_METHOD_ERROR = '[Payment] Add Payment Method Error';

export const REMOVE_PAYMENT_METHOD = '[Payment] Remove Payment Method';
export const REMOVE_PAYMENT_METHOD_SUCCESS =
  '[Payment] Remove Payment Method Success';
export const REMOVE_PAYMENT_METHOD_ERROR =
  '[Payment] Remove Payment Method Error';
